
import routes from "@/routers/routes";
import PageHeader from "../page-header";
import CreateEditPartner from "@/app/shared/settings/partners/create-edit";


export default function CreatePartnerPage() {
    const pageHeader = {
        title: "Create Partner",
        breadcrumb: [
            {
                href: routes.settings.partners.list,
                name: "home",
            },
            {
                name: "Add New Partner",
            },
        ],
    };

    return (
        <>
            <PageHeader
                title={pageHeader.title}
                hideButton={true}
            ></PageHeader>

            <CreateEditPartner isEdit={false} />
        </>
    );
}

